export const URLRegexp = RegExp("^(([^:/?#]+):)+(//([^/?#]*))+([^?#]*)(\\\\?([^#]*))?(#(.*))?")